import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=10f774ab"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports